module.exports = __webpack_public_path__ + "static/img/fav_192-01.204fc81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fav_192-01.png
// module id = 2990
// module chunks = 1